

// ==============================|| MAIN CARD ||============================== //

export default function Footer() {
  return (
    <footer className="pc-footer">
      <div className="footer-wrapper  container-fluid">
        <div className="justify-content-center justify-content-md-between row">
          {/* <div className="my-1 col-auto">
            <p className="m-0">
              Datta Able ♥ Crafted By Team{"{"}" "{"}"}
              <a
                href="https://codedthemes.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary"
              >
                CodedThemes
              </a>
            </p>
          </div> */}
          <div className="my-1 col-auto">
            <div className="justify-content-center hstack gap-3">
              <a href="/" className="p-0 nav-link">
                Home
              </a>
              <a
                href="https://codedthemes.gitbook.io/datta"
                target="_blank"
                rel="noopener noreferrer"
                className="p-0 nav-link"
              >
                Documentation
              </a>
              <a
                href="https://codedthemes.support-hub.io/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-0 nav-link"
              >
                Support
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
